import { store } from '@/app/app-store';
import { UserInfoModel, UserDetail, ProfileModel } from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { env } from '@/environments';
import { PermissionModel } from '../../models/auth/permission.model';
import { ChangePasswordModel } from '../../models/auth/change-password.model';

@Module({ store, name: 'userModule', namespaced: true, dynamic: true })
export class UserModule extends VuexModule {
  public userInfo: UserInfoModel = new UserInfoModel();
  public userDetail: UserDetail = new UserDetail();
  public profiles: ProfileModel[] = [];
  public permissions: string[] = [];

  @Mutation
  public SET_USER_INFO(userInfo: UserInfoModel) {
    this.userInfo = userInfo;
  }
  @Mutation
  public SET_USER_DETAIL(userDetail: UserDetail) {
    this.userDetail = userDetail;
  }
  @Mutation
  public SET_PROFILES(profiles: ProfileModel[]) {
    this.profiles = profiles;
  }
  @Mutation
  public SET_PERMISSION_LIST(permissions: string[]) {
    this.permissions = permissions;
    localStorage.setItem('permissions', JSON.stringify(permissions));
  }

  @Action({ commit: 'SET_USER_INFO', rawError: true })
  public async loadUserInfo() {
    const user = await refs.services.user.getUserInfo();
    return user;
  }

  @Action({ commit: 'SET_USER_DETAIL', rawError: true })
  public async loadUserById(id: string) {
    const user = await refs.services.user.getUserById(id);
    return user;
  }

  @Action({ commit: 'SET_PROFILES', rawError: true })
  public async loadProfiles(userProfiles: ProfileModel[]) {
    await refs.modules.user.loadPermissionList({
      rolesIds: userProfiles.map((role) => {
        return role.Id;
      }),
      isOwner: !!this.userInfo.owner,
    });

    return userProfiles;
  }

  @Action({ commit: 'SET_PERMISSION_LIST', rawError: true })
  public async loadPermissionList(data: {
    rolesIds: string[];
    isOwner: boolean;
  }) {
    const serviceApiUriList: string[] = [
      `${env.billingUri}`,
      `${env.financialUri}`,
      `${env.insuranceUri}`,
      `${env.customerUri}`,
    ];
    const promises: Promise<PermissionModel[]>[] = [];
    serviceApiUriList.map(async (serviceApiUri) => {
      if (data.isOwner) {
        promises.push(refs.services.user.loadActionList(serviceApiUri));
      } else {
        promises.push(
          refs.services.user.loadPermissionList(serviceApiUri, data.rolesIds)
        );
      }
    });

    const permissionList: string[] = [];
    const promisesPermissions = await Promise.all(promises);
    promisesPermissions.map((permissions) => {
      permissions.map((permission) => {
        if (permission.Code || permission.ActionCode) {
          permissionList.push(
            permission.Code ? permission.Code : permission.ActionCode
          );
        }
      });
    });
    return refs._.uniq(permissionList);
  }

  @Action({ rawError: true })
  public async changeUserPassword(changePassword: ChangePasswordModel) {
    const user = await refs.services.user.getUserInfo();
    await refs.services.user.changeUserPassword(user.userId, changePassword);
  }
}
